export default __webpack_public_path__ + "static/media/Economics.cae7d785.svg";